module.exports = __webpack_public_path__ + "img/hibob.233f13db.svg";